"use client";

import ServicePageHero from "components/pages/service/ServicePageHero";
import styled from "styled-components";

export default function NotFound() {
  return (
    <Wrapper>
      <ServicePageHero
        title="404"
        paragraph="De pagina die je zoekt bestaat niet."
        cta={{
          text: "Terug naar home",
          url: "/",
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  h1 {
    color: ${({ theme }) => theme.theme.accent};
  }
`;
